import { HeaderContainer } from '@components/core/container/Container';
import { HeaderStyled } from './header.styled';
import { useACF } from '@context/ACFContext';

const Header = () => {
	const { generalSettings, postTemplate } = useACF();

	const backgroundColor = postTemplate?.review_page_v4_header_settings.background_color;

	if (!generalSettings || !backgroundColor) return;

	return (
		<HeaderStyled $backgroundColor={backgroundColor} id="main-product">
			<HeaderContainer>
				<img src={generalSettings.logo} alt={generalSettings.brand_name} />
			</HeaderContainer>
		</HeaderStyled>
	);
};

export default Header;
